import { NgModule } from "@angular/core";
import { AnimationCarouselCardComponent } from "./animation-carousel-card.component";
import { CommonModule } from "@angular/common";
import { SharedModule } from "src/app/shared/shared.module";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  imports: [CommonModule, SharedModule, TranslateModule],
  exports: [AnimationCarouselCardComponent],
  declarations: [AnimationCarouselCardComponent],
})
export class AnimationCarouselCardModule {}
